import React, { forwardRef, useState } from 'react';
import '../../styles/vendorregistration.css';
import { FaUserDoctor } from "react-icons/fa6";
import { FaUserTie } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';

const VendorTypePage = forwardRef(({
  formData,
  updateFormData,
  errors,
  handleFieldFocus,
  registerFieldRef,
  professionalsList
}, ref) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState(formData.vendorType.type || '');
  const [selectedProfessional, setSelectedProfessional] = useState(formData.vendorType.professional || '');

  const vendorTypes = [
    {
      id: 'Hospital',
      name: t('vendorRegistration.vendorTypes.hospital'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="currentColor" fillRule="evenodd" d="M10.75 2h2c1.886 0 2.828 0 3.414.586S16.75 4.114 16.75 6v15.25h5a.75.75 0 0 1 0 1.5h-20a.75.75 0 0 1 0-1.5h5V6c0-1.886 0-2.828.586-3.414S8.864 2 10.75 2m1 2.25a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5H12.5V9A.75.75 0 0 1 11 9V7.75H9.75a.75.75 0 0 1 0-1.5H11V5a.75.75 0 0 1 .75-.75M9 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9 12m0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9 15m2.75 3.25a.75.75 0 0 1 .75.75v2.25H11V19a.75.75 0 0 1 .75-.75" clipRule="evenodd"></path><path fill="currentColor" d="M20.913 5.889c.337.504.337 1.206.337 2.611v12.75h.5a.75.75 0 0 1 0 1.5h-20a.75.75 0 1 1 0-1.5h.5V8.5c0-1.405 0-2.107.337-2.611a2 2 0 0 1 .552-.552c.441-.295 2.537-.332 3.618-.336q-.005.437-.004.91V7.25H4.25a.75.75 0 1 0 0 1.5h2.503v1.5H4.25a.75.75 0 0 0 0 1.5h2.503v1.5H4.25a.75.75 0 0 0 0 1.5h2.503v6.5h10v-6.5h2.497a.75.75 0 1 0 0-1.5h-2.497v-1.5h2.497a.75.75 0 1 0 0-1.5h-2.497v-1.5h2.497a.75.75 0 0 0 0-1.5h-2.497V5.91q.001-.471-.004-.91c1.081.005 3.17.042 3.612.337a2 2 0 0 1 .552.552" opacity={0.5}></path></svg>
      )
    },
    {
      id: 'Clinic',
      name: t('vendorRegistration.vendorTypes.clinic'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="currentColor"><path d="M11 4.5a1.5 1.5 0 0 1 3 0V5h.5a1.5 1.5 0 0 1 0 3H14v.5a1.5 1.5 0 0 1-3 0V8h-.5a1.5 1.5 0 1 1 0-3h.5zm1.5-.5a.5.5 0 0 0-.5.5V6h-1.5a.5.5 0 0 0 0 1H12v1.5a.5.5 0 0 0 1 0V7h1.5a.5.5 0 0 0 0-1H13V4.5a.5.5 0 0 0-.5-.5" /><path d="M16 1a2 2 0 0 1 2 2h4a2 2 0 0 1 2 2v13H11a3 3 0 0 0-3 3v9H5V5a2 2 0 0 1 2-2a2 2 0 0 1 2-2zM8 3v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1" /><path d="M9 30h2v-1.5a.5.5 0 0 1 .5-.5h2v2H15v-2h2a.5.5 0 0 1 .5.5V30H20v-1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V30h2v-9a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2zm2.75-9h13.5a.75.75 0 0 1 0 1.5h-13.5a.75.75 0 0 1 0-1.5m0 2.5h13.5a.75.75 0 0 1 0 1.5h-13.5a.75.75 0 0 1 0-1.5" /></g></svg>
      )
    },
    {
      id: 'Laboratory',
      name: t('vendorRegistration.vendorTypes.laboratory'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M6.047 9.375a3 3 0 1 0 0-6a3 3 0 0 0 0 6m-.5-8.25h1m-.5 0v2.25m3.359-1.066l.707.707m-.354-.353L8.168 4.254m3.129 1.621v1m0-.5h-2.25m1.066 3.359l-.707.707m.353-.354L8.168 8.496m-1.621 3.129h-1m.5 0v-2.25m-3.359 1.066l-.707-.707m.354.353l1.591-1.591M.797 6.875v-1m0 .5h2.25M1.981 3.016l.707-.707m-.353.354l1.591 1.591M18.146 9.1a6.134 6.134 0 0 1 .315 9.07a6.4 6.4 0 0 1-8.941 0a6.2 6.2 0 0 1-1.558-2.52" /><path d="M16.151 11.054a.913.913 0 0 1-1.277 0L13.6 9.8a.875.875 0 0 1 0-1.254l3.832-3.764a.915.915 0 0 1 1.277 0l1.277 1.255a.875.875 0 0 1 0 1.254z" /><path d="m19.168 5.236l2.59-2.592l-1.445-1.445m2.89 2.89l-1.445-1.445M5.797 15.65h5.058m-4.27 7.225h13.728m-6.503-2.89v2.89" /></g></svg>
      )
    },
    {
      id: 'Pharmacy',
      name: t('vendorRegistration.vendorTypes.pharmacy'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 14 14"><path fill="currentColor" fillRule="evenodd" d="M10.103 1.071L8.135 4.156h3.083l1.084-1.668a1.308 1.308 0 1 0-2.2-1.417ZM1.067 8.848l-.29-2.58a1 1 0 0 1 .994-1.111h10.458a1 1 0 0 1 .994 1.112l-.29 2.58a4 4 0 0 1-2.055 3.062c.156.307.266.643.32 1a.816.816 0 0 1-.808.937H3.61a.816.816 0 0 1-.808-.937a3.3 3.3 0 0 1 .32-1a4 4 0 0 1-2.055-3.063m6.558-1.275a.625.625 0 1 0-1.25 0v1.304H5.071a.625.625 0 1 0 0 1.25h1.304v1.305a.625.625 0 1 0 1.25 0v-1.304h1.304a.625.625 0 0 0 0-1.25H7.625V7.571Z" clipRule="evenodd" /></svg>
      )
    },
    {
      id: 'Single Doctor',
      name: t('vendorRegistration.vendorTypes.singleDoctor'),
      icon: <FaUserDoctor size={25} />
    },
    {
      id: 'Single Nurse',
      name: t('vendorRegistration.vendorTypes.singleNurse'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48"><g fill="currentColor" fillRule="evenodd" clipRule="evenodd"><path d="M24 6c-2.806 0-6.238 1.026-8.264 1.731c-.988.344-1.483 1.417-1.156 2.41l2.148 6.521a8 8 0 1 0 14.544 0l2.148-6.52c.327-.994-.168-2.067-1.156-2.41C30.237 7.025 26.806 6 24 6m-5.62 12.425c3.757-1.543 7.483-1.543 11.24 0q.09.037.186.056a6 6 0 1 1-11.613 0q.096-.019.187-.056M25 11h2v2h-2v2h-2v-2h-2v-2h2V9h2z" /><path d="M22.85 32.193L16.88 28S6 31.393 6 35.467V42h36v-6.533C42 31.393 31.121 28 31.121 28l-5.972 4.193a2 2 0 0 1-2.298 0M32 32h2v2h2v2h-2v2h-2v-2h-2v-2h2z" /></g></svg>
      )
    },
    {
      id: 'other',
      name: t('vendorRegistration.vendorTypes.other'),
      icon: <FaUserTie size={25} />
    }
  ];

  const handleTypeSelect = (typeId) => {
    setSelectedType(typeId);

    if (typeId !== 'other' && selectedProfessional) {
      setSelectedProfessional('');
      updateFormData('vendorType', 'professional', '');
      updateFormData('vendorType', 'singleUser', false);
    }

    updateFormData('vendorType', 'type', typeId);
    handleFieldFocus('vendorType', 'type');
  };

  const handleProfessionalChange = (e) => {
    const { value } = e.target;
    setSelectedProfessional(value);
    updateFormData('vendorType', 'professional', value);
    if (value) {
      updateFormData('vendorType', 'singleUser', true);
      handleFieldFocus('vendorType', 'type');
    };
  };

  return (
    <div ref={ref}>
      <h2 className="page-title">{t('vendorRegistration.headers.step2')}</h2>
      <p className="page-description">{t('vendorRegistration.subdescriptions.step2')}</p>

      <div className="vendor-type-grid">
        {vendorTypes.map((type) => (
          <div
            key={type.id}
            className={`vendor-type-option ${selectedType === type.id ? 'selected' : ''}`}
            onClick={() => handleTypeSelect(type.id)}
          >
            <div className={`option-icon ${type.id}`}>
              <span className="icon-placeholder" style={{ display: 'flex' }}>
                {type.icon}
              </span>
            </div>
            <span className="option-name">{type.name}</span>
          </div>
        ))}
      </div>

      {errors.vendorType?.type && (
        <div className="error-message vendor-type-error">{t(`vendorRegistration.errors.${errors.vendorType?.type}`)}</div>
      )}

      {selectedType === 'other' && (
        <>
          <div className="form-conditional">
            <label htmlFor="professional">{t('vendorRegistration.selectProfession')}</label>
            <div className="input-container">
              <select
                id="professional"
                className={`custom-dropdown ${errors.vendorType?.professional ? 'error' : ''}`}
                value={selectedProfessional}
                onChange={handleProfessionalChange}
                onFocus={() => handleFieldFocus('vendorType', 'professional')}
                ref={(el) => registerFieldRef('professional', el)}
              >
                <option value="">{t('vendorRegistration.selectProfessionPlaceholder')}</option>
                {professionalsList.map((prof, index) => (
                  <option key={index} value={prof}>
                    {t(`professionalsList.${prof}`)}
                  </option>
                ))}
              </select>
            </div>
            {errors.vendorType?.professional && (
              <div className="error-message">{errors.vendorType?.professional}</div>
            )}
          </div>

          {/* <div className="form-group" style={{ display: 'flex', alignItems: "center", flexDirection: "row", gap: '8px' }}>
            <label style={{ fontSize: '15px' }}>
              {t('vendorRegistration.formLabels.singleUser')}
            </label>
            <input
              type="checkbox"
              checked={formData.vendorType.singleUser || false}
              onChange={(e) => updateFormData('vendorType', 'singleUser', e.target.checked)}
              disabled
              style={{ width: '14px', height: '14px' }}
            />
          </div> */}
        </>
      )}
    </div>
  );
});

export default VendorTypePage;